export const colors = ['#d6cbd4', '#e1ecef', '#efe8e1', '#e8efe1', '#e1efeb', '#e1e2ef'];